define([
    'query-string',
], (queryString) => {

    return [() => ({
        getPromotion: (windowLocationSearch) => {
            let result;

            const searchParams = queryString.parse(windowLocationSearch);
            const { promotion } = searchParams;
            if (promotion) {
                result = {};
                result.title = promotion;

                // Up to 3 promotion items are supported:
                result.promotionItems = [1, 2, 3]
                    .map((pos) => {
                        const titleKey = `promo_title${pos}`;
                        const codeKey = `promo_code${pos}`;
                        // Max length 60:
                        const titleValue = searchParams[titleKey] ? searchParams[titleKey].substring(0, 60) : null;
                        const codeValue = searchParams[codeKey] ? searchParams[codeKey].substring(0, 60) : null;
                        return {sortID: pos, label: titleValue, code: codeValue};
                    })
                    .filter(it => it.label !== null || it.code !== null);
                // a promotion without items makes no sense. Therefore it is ignored:
                result = result.promotionItems.length === 0 ? undefined : result;
            }

            return result;
        },

        showPromotionOnGUI: (promotion) => {
            // promotion section will only be shown, when it has at least one item with a label:
            return promotion && promotion.promotionItems && promotion.promotionItems.value.filter(it => it.label).length > 0;
        },
        getItems: (promotion) => {
            return promotion && promotion.promotionItems && promotion.promotionItems.children
                .map((promotionItem) => {
                    return {
                        promotionItem: promotionItem,
                        readOnly: Boolean(promotionItem.code.value),
                        hasLabel: Boolean(promotionItem.label.value),
                    };
                })
                .sort((a, b) => a.promotionItem.value.sortID - b.promotionItem.value.sortID);


        },


    })];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/services/MFPPromotionService.js